import React from 'react';

import Chip from '@mui/material/Chip';

/**
 * ラベル Chip。
 * ラベルは動的な色（label.color の HEX）を持つため、専用 enum Chip ではなく色を prop で受ける。
 * 論理削除済みラベルも記事の一覧/詳細では Chip として表示する（色はそのまま使用）。
 */
type Props = {
  name: string;
  /** HEX 色コード（#RRGGBB / #RRGGBBAA） */
  color: string;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
  onClick?: () => void;
  onDelete?: () => void;
};

const LabelChip: React.FC<Props> = ({
  name,
  color,
  size = 'small',
  variant = 'outlined',
  onClick,
  onDelete,
}) => {
  return (
    <Chip
      label={name}
      size={size}
      variant={variant}
      onClick={onClick}
      onDelete={onDelete}
      sx={{
        color: variant === 'outlined' ? color : '#fff',
        borderColor: color,
        backgroundColor: variant === 'filled' ? color : undefined,
        cursor: onClick ? 'pointer' : 'default',
        fontWeight: 500,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
        '& .MuiChip-deleteIcon': {
          color: variant === 'outlined' ? color : '#fff',
        },
      }}
    />
  );
};

export default LabelChip;
